export const contactTagsBulkModalId = 'contactTagsBulkModal' as const
export const contactTagsBulkFormId = 'ContactBulkFormService' as const
